import { FormInitializerReturnType, stringSchema } from 'src/Configuration/validation'
import { SettingsFormValues } from '../types'
import { boolean, object, tuple } from 'yup'
import { PowerMeterModel } from '../models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { modelToForm } from '../transformer'

const DEVICE_NAME_MIN_LENGTH = 1
const DEVICE_NAME_MAX_LENGTH = 20

/**
 *  Initializes the form for editing power meter settings
 * @param model PowerMeterModel
 * @returns initialValues and validationSchema for power meter settings form
 */
export const usePowerMeterSettingsFormInitializer = (model?: PowerMeterModel): FormInitializerReturnType<SettingsFormValues, SettingsFormValues> => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const initialValues = modelToForm(model)
  const validationSchema = object().shape({
    deviceName: stringSchemaWithTranslation({ minLength: DEVICE_NAME_MIN_LENGTH, maxLength: DEVICE_NAME_MAX_LENGTH }).trim().required(),
    balancedPhases: tuple([boolean().required(), boolean().required(), boolean().required()]).required(),
    phaseElimination: tuple([boolean().required(), boolean().required(), boolean().required()]).required(),
  })
  return { initialValues, validationSchema }
}
